export default __webpack_public_path__ + "static/ServerSideDev-f87c640367dcbc0eb432c987d4214d63.svg";